module.exports = __webpack_public_path__ + "media/svg/bw-84fea591.svg";